import React, { useState, useEffect, useRef } from "react";
import { inject, observer } from "mobx-react"; // eslint-disable-line
import axios from "axios";
import Countdown from "react-countdown";

const GCXNext = (props) => {
  const timer = useRef(0);

  /// USE STATE

  const [state, setState] = useState({
    startTime: 0,
    endTime: 0,
    streamer: "loading",
  });
  const [upNext, setUpNext] = useState("loading");

  const [timeLeft, setTimeLeft] = useState(10000);

  /// USE EFFECT

  useEffect(() => {
    /* Remove for production */
    const url = `${process.env.REACT_APP_LOCAL_URI}/gcx-next/`;
    /* Remove for production */

    let streamer = window.location.href.replace(url, "").split("/");
    if (streamer[0][0] === "@" || streamer[0][0] === "+") {
      streamer[2] = streamer[0][0];
      streamer[0] = streamer[0].substr(1, streamer[0].length);
    } else {
      streamer[2] = "@";
    }

    if (streamer[0] !== "") {
      let streamType = streamer[2],
        username = streamer[0],
        slug = streamer[1];

      /* Remove for production */
      props.gcxStore.socketConnect(streamType, username, slug);

      receive();

      timer.current = setInterval(() => receive(), 10000);

      return () => props.gcxStore.socketDisconnect();
    }
    //props.userStore.getAccessToken();
  }, []);

  /// FUNCTIONS

  const receive = () => {
    const URL = process.env.REACT_APP_GCX_SERVICE_URI + "/getGcxMarathon";

    axios
      .post(URL)
      .then((response) => {
        // client.nextup = response.data.nextup;
        // console.log('next up', client.nextUp)
        // console.log(response.data);
        setState((prev) => {
          return {
            ...prev,
            startTime: response.data[0].start_timestamp,
            endTime: response.data[0].end_timestamp,
            streamer: response.data[0].streamer,
          };
        });
        setUpNext(response.data[1].streamer);
        // console.log("NextUp back from PG write", response);
      })
      .catch((err) => console.log("***** write to PG error:", err));
  };

  useEffect(() => {
    const start = new Date();
    const end = new Date(state.endTime);
    //   console.log(end);
    //   console.log(start);
    //   console.log(
    //     "hours end",
    //     end.getUTCHours(),
    //     end.getUTCMinutes(),
    //     end.getUTCSeconds()
    //   );
    //   console.log(
    //     "hours now",
    //     start.getHours(),
    //     start.getMinutes(),
    //     start.getSeconds()
    //   );

    const toMilliseconds = (hrs, min, sec) =>
      (hrs * 60 * 60 + min * 60 + sec) * 1000;
    setTimeLeft(
      Number(
        toMilliseconds(
          end.getUTCHours(),
          end.getUTCMinutes(),
          end.getUTCSeconds()
        ) -
          toMilliseconds(
            start.getHours(),
            start.getMinutes(),
            start.getSeconds()
          )
      )
    );

    // console.log(timeLeft);
  }, [receive]);

  Number.prototype.zeroPad = function () {
    return ("0" + this).slice(-2);
  };

  const renderer = ({ hours, minutes }) => {
    return (
      <span>
        {hours}:{minutes.zeroPad()}
      </span>
    );
  };

  return (
    <div className="gcx-next">
      <div className="countdown">
        {state.streamer} -{" "}
        <Countdown
          date={Date.now() + timeLeft}
          //   intervalDelay={0}
          //   precision={3}
          renderer={renderer}
          daysInHours={true}
          zeroPadTime={2}
        />
      </div>
      {/* <div className="upnext">Up Next: {upNext}</div> */}
      <div className="upnext">
        {upNext === "Darkness429" ||
        upNext === "Chefsteve330" ||
        upNext === "alltimebrianna" ||
        upNext === "Aztecross" ||
        upNext === "CtrlAltQuin" ||
        upNext === "Kruzadar" ||
        upNext === "BigDaddyTeej" ||
        upNext === "Leopard & Datto"
          ? "Tomorrow: "
          : "Up Next: "}{" "}
        {upNext}
      </div>
    </div>
  );
};

export default inject("gcxStore")(observer(GCXNext));
